import { render, staticRenderFns } from "./FinancialControlWorkspace.vue?vue&type=template&id=3288ab76&scoped=true"
import script from "./FinancialControlWorkspace.vue?vue&type=script&lang=js"
export * from "./FinancialControlWorkspace.vue?vue&type=script&lang=js"
import style0 from "./FinancialControlWorkspace.vue?vue&type=style&index=0&id=3288ab76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288ab76",
  null
  
)

export default component.exports